import React from 'react';
import { Timeline } from 'antd';
import styles from './recentActivities.module.scss';

const activityData = [
  {
    title: '5 attendees requested refunds',
    description: 'Mostly from last-minute cancellations on Event X.',
    color: 'green',
    emotion: 'sad'
  },
  {
    title: '12 guests left feedback',
    description: 'Average rating was 4.2 stars.',
    color: 'blue',
    emotion: 'happy'
  },
  {
    title: '2 events are over capacity',
    description: 'Concert A and Meetup B need larger venues.',
    color: 'red',
    emotion: 'fire'
  },
  {
    title: 'New event got 50 signups!',
    description: 'Pitch Night went viral.',
    color: 'gold',
    emotion: 'excited'
  },
  {
    title: 'John created a new campaign',
    description: 'Campaign “SummerFest” launched successfully.',
    color: 'cyan',
    emotion: 'happy' // replaced image with emoji
  }
];

const emotionIconMap = {
  happy: '😊',
  sad: '😢',
  fire: '🔥',
  excited: '🎉',
  neutral: '😐'
};

const RecentActivities = ({ activities = activityData }) => (
  <Timeline className={styles.timeline}>
    {activities.map((item, index) => {
      const dot = (
        <div className={styles.emojiDot}>
          {emotionIconMap[item.emotion] || emotionIconMap.neutral}
        </div>
      );

      return (
        <Timeline.Item key={index} color={item.color || 'gray'} dot={dot}>
          <div className={styles.title}>{item.title}</div>
          {item.description && (
            <div className={styles.description}>{item.description}</div>
          )}
        </Timeline.Item>
      );
    })}
  </Timeline>
);

export default RecentActivities;
